import {Injectable} from "@angular/core";
import {HttpRequestor} from "../common/HttpRequestor";
import {Constants} from "../common/Constants";
import {HttpParams, HttpHeaders} from "@angular/common/http";
import {Utils} from "../utils/prochart.utils";

@Injectable()
export class ChartService {
  private tonce;

  constructor(private httpRequestor: HttpRequestor) {
    this.tonce = (Date.now() + 1000).toString()
  }

  exchangeDerivedRecords(global, base_cur_name, quote_cur_name, freq, aggregate, exchange_id, start, end, time): Promise<any> {
    let path = Constants.API_ROOT + '/exchange_derived_records';
    let httpParams = new HttpParams()
      .append('global', global)
      .append('base_cur_name', base_cur_name)
      .append('quote_cur_name', quote_cur_name)
      .append('freq', freq)
      .append('aggregate', aggregate)
      .append('exchange_id', exchange_id)
      .append('tonce', this.tonce)
      .append('auth_key', Constants.KEY)
      .append('start', start)
      .append('end', end)
      .append('time', time);

    let headers = this.createSignature(httpParams);

    return this.httpRequestor.getRequest(path, headers, httpParams)
  }

  marketsRequest(): Promise<any> {
    let path = Constants.API_ROOT + '/markets';
    let httpParams = new HttpParams()
      .append('tonce', this.tonce)
      .append('auth_key', Constants.KEY);

    let headers = this.createSignature(httpParams);

    return this.httpRequestor.getRequest(path, headers, httpParams);
  }

  testApiAuth(): Promise<any> {
    let path = Constants.API_ROOT2 + 'gateway/dqrx/public/authenticate';
    let httpParams = new HttpParams();
    /*.append('tonce', this.tonce)
    .append('auth_key', Constants.KEY);*/

    let headers = new HttpHeaders();//this.createSignature(httpParams);

    return this.httpRequestor.postRequest(path, {
      "username": "butters@test.test",
      "password": "butterstest"
    }, headers, httpParams);
  }

  testApiRequest(token): Promise<any> {
    let path = Constants.API_ROOT2 + 'gateway/private/buy';
    let httpParams = new HttpParams();

    /*.append('tonce', this.tonce)
    .append('auth_key', Constants.KEY);*/

    let headers = new HttpHeaders().append('Auth-Token', token);//this.createSignature(httpParams);

    return this.httpRequestor.postRequest(path, {
      "market": "BTC-EUR",
      "nominal": 0.01,
      "limit": 0,
      "pauseNoCredit": false,
      "immediateOrCancel": false
    }, headers, httpParams);
  }

  testApiChart(): Promise<any> {
    let path = Constants.API_ROOT2 + 'gateway/public/chart';
    let httpParams = new HttpParams();

    /*.append('tonce', this.tonce)
    .append('auth_key', Constants.KEY);*/

    let headers = new HttpHeaders();//.append('Auth-Token', token);//this.createSignature(httpParams);

    return this.httpRequestor.postRequest(path, {
      "charts": [
        {
          "ident": "dqrx-test bid based BTC-ETH 4h weighted average",
          "market": "BTC-ETH",
          "from": 111111
        }
      ],
      "openIntervals": true
    }, headers, httpParams);
  }



  createSignature(httpParams): HttpHeaders {
    let message = httpParams.toString();
    let hmac_sign = Utils.getMessageSignature(message);

    let headers = new HttpHeaders({'Content-Type': 'application/json'})
      .append('X-Signature', hmac_sign);

    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/chart.sevice.ts